export interface PostHogGateInput {
  tenantAnalyticsOptIn: boolean;
  key?: string;
  host?: string;
}

export interface PostHogConfig {
  enabled: boolean;
  key: string;
  host: string;
  tenantId: string;
  sessionReplay: boolean;
}

export function shouldEnablePostHog(input: PostHogGateInput): boolean {
  return Boolean(input.tenantAnalyticsOptIn && input.key && input.host);
}

export function buildPostHogConfig({
  tenantId,
  tenantAnalyticsOptIn,
  key,
  host,
}: PostHogGateInput & { tenantId: string }): PostHogConfig {
  const enabled = shouldEnablePostHog({ tenantAnalyticsOptIn, key, host });
  return {
    enabled,
    key: key ?? "",
    host: host ?? "",
    tenantId,
    sessionReplay: enabled,
  };
}
